import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FloatingElementDirective } from '../../directives/floating-element.directive';
import { FloatingMenuAnchorDirective } from './floating-menu-anchor.directive';
import { SIGNAL } from '@angular/core/primitives/signals';

@Component({
  selector: 'shared-core-floating-menu',
  template: ` <ng-content select="shared-core-floating-menu-item" /> `,
  hostDirectives: [
    {
      directive: FloatingElementDirective,
      inputs: ['isOpened', 'anchor', 'placement', 'offsetConfig', 'trigger'],
      outputs: ['outsideClick'],
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FloatingMenuComponent {
  /**
   * Instead of passing the anchor as an input, one can just add
   * the directive on the anchor element:
   *
   * ```
   * <div floatingMenuAnchor>
   *   ...
   *      ...
   *      <shared-core-floating-menu>...</shared-core-floating-menu>
   *      ...
   *   ...
   * </div>
   * ```
   */
  protected readonly anchor = inject(FloatingMenuAnchorDirective, { optional: true });

  protected readonly floatingElement = inject(FloatingElementDirective);

  constructor() {
    if (this.anchor) {
      // sadly, it's still impossible to pass component inputs to host directive inputs
      // https://github.com/angular/angular/issues/50510
      this.floatingElement.anchor[SIGNAL].value = this.anchor.element.nativeElement;
    }
  }
}
